import React from 'react'
import './Button.scss';

const Button = ( props ) => {
    return (
        <button className='buttonContainer' type={props.type}>
            {props.toDo}
        </button>
    )
}

export default Button
